import { IPagination } from "../../IPagination";
import { AuditAuthor } from "../IAuditAuthor";

export type ITrip = {
  lineId: number;
  departureTime: string;
  arrivalTime: string;
  // The whole trip length in minutes, 0 when no length is known. May exceed 24h
  // (multi-day trips); the arrival clock wraps at 24h and cannot show that.
  durationMinutes: number;
  updated?: boolean;
  isReservable: boolean;
  // isActive: boolean;
  operationalIntervalId?: number;
  ticketsCount?: number;
  oldId?: number;
  defaultCurrencyId: number;
  departureTimeString: string;
  arrivalTimeString: string;
  id: number;
  deleted?: boolean;
  insertDate?: string;
  count?: number;
};

export type IOperationalInterval = {
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
};

export type ISchedules = {
  tripId?: number;
  stationId: number;
  arrivalTime: string;
  departureTime: string;
  duration: number;
  arrivalTimeString: string;
  departureTimeString: string;
  id: number;
};

export enum OperatorCommisionFeePaymentTypes {
  JourneyReservation = 1,
  TravelBundle = 2
}

export enum OperatorCommisionFeeValueTypes {
  Percentage = 1,
  FixedValue = 2
}

export type IEntityCommissionFee = {
  fee: number;
  paymentType: OperatorCommisionFeePaymentTypes;
  valueType: OperatorCommisionFeeValueTypes;
};

export type ITripType = {
  hasGTFS?: boolean;
  hasCustomReservableDates?: boolean;
  routeName: string;
  routeDescription: string;
  trip: ITrip;
  operationalInterval: IOperationalInterval;
  schedules: ISchedules[];
  prices: [number, number];
  customWorkingDays?: CustomTripWorkingDayRequest[];
  entityCommissionFee?: IEntityCommissionFee | null;
} & AuditAuthor;

export type CustomTripWorkingDayRequest = {
  type: CustomTripWorkingDayType;
  date: Date;
};

export enum CustomTripWorkingDayType {
  ExceptionDate = 1,
  SelectedWorkingDate = 2
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ITrips extends IPagination<ITripType> {}
